var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ds-status',{attrs:{"emphasis":"high","type":_vm.$options.SMS_BROADCAST_STATUS_MESSAGE_TYPE[`${_vm.status}`]}},[_vm._v(" "+_vm._s(_vm.$options.SMS_BROADCAST_STATUS_INDICATOR_MESSAGE[`${_vm.status}`])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }